import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";

export const useMyPublicationCollaboratorsCollaboratorFeedStore = defineSmartFeedPiniaStore(
  "my-publication-collaborators-collaborator-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        publicationId: {
          "key": "publication_id",
          "payload": useCreatorPublicationStore().publicationId,
        },
        collaboratorType: {
          "key": "collaborator_type",
          "payload": "collaborator",
        },
      },
      tableFields: [
        { key: "name", label: "Name" },
        { key: "email", label: "Email" },
        { key: "role", label: "Role" },
        { key: "compensation", label: "Compensation" },
        { key: "status", label: "Status" },
        { key: "actions", label: "" },
      ],
    }),
    getters: {
      feedUrl() {
        return `/publication/${useCreatorPublicationStore().publicationId}/collaborators/filtered`;
      },
    },
  },
);
